import type { ReactNode } from 'react';

import { DeviceIconContent } from '@/components/device-icon/device-icon-content';
import type { FaultedDevice } from '@/features/equipment-browser/faulted-devices/faulted-devices.types';
import { Inline } from '@/ux-common/components/inline/inline';
import { Typography } from '@/ux-common/components/typography/typography';

interface ResetFaultedNameCellProps {
  device: FaultedDevice;
}

/** Device icon with the device's display name. Icon refs are subscribed by the table. */
export const ResetFaultedNameCell = ({ device }: ResetFaultedNameCellProps): ReactNode => {
  const { deviceIcon, referenceId, title } = device.summary;

  return (
    <Inline
      className="inline-row-xs flex-nowrap items-center h-full min-w-0 px-gutter-sm"
      data-component="ResetFaultedNameCell"
    >
      <DeviceIconContent aria-hidden deviceId={referenceId} icon={deviceIcon} />
      <Typography as="span" className="text-body-sm text-foreground truncate">
        {title}
      </Typography>
    </Inline>
  );
};
